import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { useWindowDimensions } from '../componentes/FuncionesLocales';

const formatYMD = (d) => {
  // Recibe Date (local) y devuelve YYYY-MM-DD
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

// Valida si un string ya está en formato YYYY-MM-DD
const isYMD = (s) => typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s);

// Construye un Set de fechas destacadas SIN parsear strings a Date
const buildHighlightedSet = (dates) => {
  const set = new Set();
  (dates || []).forEach((item) => {
    if (!item) return;

    // Si ya viene como YYYY-MM-DD lo guardamos literal
    if (isYMD(item)) { set.add(item); return; }

    // Si viene como Date, lo formateamos local
    if (item instanceof Date && !Number.isNaN(item.getTime())) {
      set.add(formatYMD(item));
      return;
    }

    // Si viene como objeto con { fecha | Fecha } en string YYYY-MM-DD, lo usamos literal
    if (typeof item === 'object' && (item.fecha || item.Fecha)) {
      const s = item.fecha || item.Fecha;
      if (isYMD(s)) { set.add(s); return; }
      // Si vino en otro formato, último recurso: intentar Date pero puede desfasar
      const parsed = new Date(s);
      if (!Number.isNaN(parsed.getTime())) set.add(formatYMD(parsed));
      return;
    }

    // Último recurso: numbers/otros (timestamp)
    if (typeof item === 'number') {
      const d = new Date(item);
      if (!Number.isNaN(d.getTime())) set.add(formatYMD(d));
      return;
    }

    // Si vino string pero NO es YYYY-MM-DD, mejor no arriesgar parse UTC
    if (typeof item === 'string') {
      // No lo agregamos para evitar falsos positivos por timezone
    }
  });
  return set;
};

export default function Calendario({
  Fecha, setFecha,
  Ancho, SoloMes, DesdeHoy, SoloAnio,
  highlightedDates = []
}) {
  const { width } = useWindowDimensions();

  // SIN useMemo: construcción barata por render y a prueba de timezones
  const highlightedSet = buildHighlightedSet(highlightedDates);

  const dateTemplate = (date) => {
    try {
      // OJO: construimos Date LOCAL y lo formateamos a YYYY-MM-DD
      const tileDate = new Date(date.year, date.month, date.day);
      const tileKey = formatYMD(tileDate);

      let isSelected = false;
      if (Fecha) {
        const fDate = (Fecha instanceof Date) ? Fecha : new Date(Fecha);
        if (!Number.isNaN(fDate.getTime())) {
          isSelected = formatYMD(fDate) === tileKey;
        }
      }

      const isHighlighted = highlightedSet.has(tileKey);

      const baseStyle = {
        textAlign: "center",
        color: '#000000',
        fontSize: "1em",
        fontWeight: 'bold',
        borderRadius: '50%',
        width: '2em',
        height: '2em',
        lineHeight: '2em',
        margin: 0,
        padding: 0,
        position: 'relative'
      };

      if (isSelected) {
        return (
          <div style={{ ...baseStyle, backgroundColor: 'var(--app-brand-soft)', color: 'var(--app-brand-deep)' }}>
            {date.day}
          </div>
        );
      }

      if (isHighlighted) {
        return (
          <div style={{ ...baseStyle, backgroundColor: 'rgba(10, 224, 106, 0.18)' }}>
            {date.day}
            <div style={{
              position: 'absolute',
              bottom: '-6px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: 'rgba(10, 224, 106, 0.95)'
            }} />
          </div>
        );
      }

      return <div style={baseStyle}>{date.day}</div>;
    } catch {
      return <div style={{ textAlign: "center" }}>{date.day}</div>;
    }
  };

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar'
  });

  return (
    <div style={{ marginTop: "4px", marginBottom: "10px", width: Ancho ? String(Ancho) + "px" : "150px", zIndex: 1 }}>
      <Calendar
        id="icon"
        locale="es"
        dateFormat={SoloAnio ? "yy" : (SoloMes ? "mm/yy" : "dd/mm/yy")}
        style={{ height: "28px", width: "140px" }}
        inputStyle={{ fontSize: '14px', width: "110px", height: "40px", paddingLeft: "14px", marginRight: "10px", borderRadius: "5px", backgroundColor: 'white', color: 'black' }}
        panelStyle={{ fontSize: '18px', zIndex: 1, backgroundColor: 'white', color: 'black' }}
        showButtonBar={true} showWeek={false}
        minDate={DesdeHoy && new Date()} icon={<img src={"/Imagenes/calendario2.png"} height={"25px"} width={"20px"} />}
        nextIcon={<img src={"/Imagenes/Der.png"} height={"20px"} width={"20px"} />}
        prevIcon={<img src={"/Imagenes/Izq.png"} height={"20px"} width={"20px"} />}
        decrementIcon={<img src={"/Imagenes/Izq.png"} height={"20px"} width={"20px"} />}
        incrementIcon={<img src={"/Imagenes/Der.png"} height={"20px"} width={"20px"} />}
        dateTemplate={dateTemplate}
        value={Fecha && Fecha}
        showOnFocus={false}
        onChange={(e) => setFecha(e.value)}
        showIcon
        touchUI={width < 800 ? true : false}
      />
    </div>
  );
}
